/**
 * Bundle 组合购插件
 * 1. 保留原有 Revy Bundle 逻辑（onAddBundle 埋点、onLoad 背景图、点击弹框）
 * 2. 新增：监听新插件 bundle:open-product-detail 事件，复用弹框，回传规格变更
 */

// ========== 原有 Revy Bundle 逻辑 ==========

window.revyBundleDataLayer = window.revyBundleDataLayer || [];
window.revyBundleDataLayer.push({
  onAddBundle: function(response) {
    sessionStorage.setItem("revyOnAddBundleTime", new Date().getTime());
    window.dispatchEvent(new CustomEvent("theme:product:add"));
    if (response) {
      response.items.forEach(item => {
        var skuArr = item.variant_title ? item.variant_title.split('/') : [];
                var sensorSata = {
                    product_page_id: item.product_id,
                    product_vendor: item.vendor,
                    product_title: item.product_title,
                    variant_id: item.variant_id,
                    quantity: 1,
                    price: item.original_line_price,
                    currency_code: "JPY",
                    module_name: "bundle_add",
                    spec_arr:skuArr.map(item => { return { value: item.trim() } })
                }
                if(sessionStorage.getItem('rbu_slot_id')) sensorSata.slot_id = sessionStorage.getItem('rbu_slot_id');
                if(sessionStorage.getItem('rbu_rank')) sensorSata.rank = sessionStorage.getItem('rbu_rank');
                window.sensors && sensors.track('add_to_cart', sensorSata);
      })
    }
  }
},
{
  onLoad: function(e) {
    if (location.pathname.startsWith('/products/')) {
      var target = document.querySelector('#revy-bundles-wrapper');
      if (!target) return;
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            window.sensors && window.sensors.track('slot_exposure', {
              slot_id: 'prudcts_page_bundle',
              section_name: 'revy bundle',
              extra_data: e.title
            })
            observer.disconnect();
          }
        });
      }, { threshold: 0.5 });
      observer.observe(target);
    }
    const bundleEl = document.querySelector('#revy_bundle-' + e.id);
    if (bundleEl) {
      const bg1 = bundleEl.getAttribute("data-bundle-1-image");
      const bg2 = bundleEl.getAttribute("data-bundle-2-image");
      function applyBgImages() {
        bundleEl.querySelectorAll(".rbu-sb-tier-product-thumbnail").forEach((item, i) => {
          if (i == 0 && bg1) {
            item.style.setProperty('background-image', "url(" + bg1 + ")", 'important');
          } else if (i == 1 && bg2) {
            item.style.setProperty('background-image', "url(" + bg2 + ")", 'important');
          }
        });
      }
      applyBgImages();
      // 监听插件后续对 style 的修改，确保背景图不被覆盖
      var bgObserver = new MutationObserver(function() {
        bgObserver.disconnect();
        applyBgImages();
        bgObserver.observe(bundleEl, { subtree: true, attributes: true, attributeFilter: ['style'] });
      });
      bgObserver.observe(bundleEl, { subtree: true, attributes: true, attributeFilter: ['style'] });
      // 3秒后停止监听，避免长期占用资源
      setTimeout(function() { bgObserver.disconnect(); }, 3000);
    }
  }
});

// 原有 Revy Bundle 点击弹框逻辑（依赖 jQuery）
$(function() {
  $('body').on("click", "#revy-bundles-wrapper .rbu-sb-tier-product-title-link", function(e) {
    e.preventDefault();
    var link = $(this).attr("href");
    if (link) createRevyModal(link);
  });
  $('body').on("click", "#revy-bundles-wrapper .rbu-sb-tier-product-thumbnail", function(e) {
    e.preventDefault();
    var link = $(this).parent().find(".rbu-sb-tier-product-title-link").attr("href");
    if (link) createRevyModal(link);
  });
});

/**
 * 原有 Revy Bundle 弹框（不带事件回传）
 */
function createRevyModal(link) {
  createProductModal(link, { source: 'revy' });
}

// ========== 新插件 bundle:open-product-detail 逻辑 ==========

(function() {
  'use strict';

  // 当前新插件弹框的实例信息
  let currentInstanceId = null;
  let currentBundleIndex = null;
  let currentProductIndex = null;
  let currentColorSpec = null;
  let currentColorSelections = {};
  let currentOptions = [];
  let currentSelectedOptions = {};
  let currentVariants = [];

  // 监听组合购打开产品详情事件
  window.addEventListener('bundle:open-product-detail', function(event) {
    const detail = event.detail;
    if (!detail) return;

    // 保存实例信息
    currentInstanceId = detail.instanceId;
    currentBundleIndex = detail.bundleIndex;
    currentProductIndex = detail.productIndex;
    currentColorSpec = detail.colorSpec || null;
    currentColorSelections = detail.colorSelections ? JSON.parse(JSON.stringify(detail.colorSelections)) : {};
    currentOptions = detail.options || [];
    currentVariants = detail.variants || [];

    // 根据当前 variantId 初始化选中的选项
    var currentVariant = currentVariants.find(function(v) { return v.id === detail.variantId; });
    currentSelectedOptions = {};
    if (currentVariant && currentVariant.options) {
      currentOptions.forEach(function(opt, index) {
        currentSelectedOptions[opt.name] = currentVariant.options[index] || '';
      });
    }

    // 用 handle 构造产品页 URL
    const productUrl = '/products/' + detail.handle;
    createProductModal(productUrl, {
      source: 'bundle-extension',
      instanceId: detail.instanceId,
      bundleIndex: detail.bundleIndex,
      productIndex: detail.productIndex,
      colorSpec: currentColorSpec,
      colorSelections: currentColorSelections
    });
  });

    // 监听组合购combo-card 点击缩略图
  window.addEventListener('bundle-combo:open-product-detail', function (event) {
    const detail = event.detail;
    if (!detail) return;
    console.log('----------bundle-combo:open-product-detail', detail)
    const productUrl = '/products/' + detail.handle;
     createProductModal(productUrl, {
      source: 'bundle-extension',
    //   instanceId: detail.instanceId,
    //   bundleIndex: detail.bundleIndex,
    //   productIndex: detail.productIndex,
    //   colorSpec: currentColorSpec,
    //   colorSelections: currentColorSelections,
      remove_el:['.product-single__box__block--variant_picker']
    });
  })

  // 监听 window 上的 variant:changed 事件（_modal 后缀 section 在 variant-select-components.js 中派发）
  window.addEventListener('variant:changed', function(e) {
    if (!currentInstanceId) return;
    if (e.detail && e.detail.newVariant) {
      window.dispatchEvent(new CustomEvent('bundle:variant-changed', {
        detail: {
          instanceId: currentInstanceId,
          bundleIndex: currentBundleIndex,
          productIndex: currentProductIndex,
          variantId: e.detail.newVariant
        }
      }));

      // 变体变更后更新色指定显隐
      updateColorSpecVisibilityInModal();
    }
  });

  /**
   * 判断色指定选项是否应该显示
   */
  function shouldShowColorSpec(configKey) {
    if (!currentColorSpec || !currentColorSpec.conditions) return true;
    var conditionConfig = currentColorSpec.conditions[configKey];
    if (!conditionConfig) return true;

    var allConditionsMet = conditionConfig.conditions.every(function(cond) {
      return currentSelectedOptions[cond.name] === cond.value;
    });

    return conditionConfig.show ? allConditionsMet : !allConditionsMet;
  }

  /**
   * 更新弹框内色指定区域的显隐
   */
  function updateColorSpecVisibilityInModal() {
    var modal = document.querySelector('#jsModalOverlay');
    if (!modal || !currentColorSpec) return;
    modal.querySelectorAll('.bundle-color-spec-fieldset').forEach(function(fieldset) {
      var configKey = fieldset.dataset.configKey;
      fieldset.style.display = shouldShowColorSpec(configKey) ? '' : 'none';
    });
  }

  /**
   * 渲染色指定 UI 到弹框中
   */
  window._renderBundleColorSpec = function(container, options) {
    if (!options.colorSpec || !options.colorSpec.options) return;

    var colorSpec = options.colorSpec;
    var colorSelections = options.colorSelections || {};

    // 创建色指定样式（只添加一次）
    if (!document.querySelector('#bundle-color-spec-style')) {
      var style = document.createElement('style');
      style.id = 'bundle-color-spec-style';
      style.textContent = '\
        .bundle-color-spec-fieldset { border: none; padding: 0; margin: 16px 0 0; }\
        .bundle-color-spec-title { font-size: 14px; font-weight: 500; margin-bottom: 10px; color: var(--color--text, #333); }\
        .bundle-color-spec-items { display: flex; flex-wrap: wrap; gap: 8px; }\
        .bundle-color-spec-item { position: relative; cursor: pointer; }\
        .bundle-color-spec-item input { position: absolute; opacity: 0; width: 0; height: 0; }\
        .bundle-color-spec-label { display: inline-block; padding: 8px 16px; border: 1px solid #ddd; border-radius: 4px; font-size: 14px; transition: all 0.2s ease; color: var(--color--text, #333); }\
        .bundle-color-spec-item:hover .bundle-color-spec-label { border-color: var(--color--text, #333); }\
        .bundle-color-spec-item.is-selected .bundle-color-spec-label { border-color: var(--color--text, #333); background-color: var(--color--text, #333); color: #fff; }\
      ';
      document.head.appendChild(style);
    }

    // 找到变体选择器区域，在其后面插入色指定 UI
    var variantPicker = container.querySelector('.product-single__box__block--variant_picker');
    if (!variantPicker) variantPicker = container.querySelector('variant-radios');
    var insertTarget = variantPicker || container.querySelector('.js-content') || container;

    Object.keys(colorSpec.options).forEach(function(configKey) {
      var config = colorSpec.options[configKey];
      var selections = colorSelections[configKey] || [];

      var fieldset = document.createElement('fieldset');
      fieldset.className = 'bundle-color-spec-fieldset';
      fieldset.dataset.configKey = configKey;

      // 判断初始显隐
      if (!shouldShowColorSpec(configKey)) {
        fieldset.style.display = 'none';
      }

      var legend = document.createElement('div');
      legend.className = 'bundle-color-spec-title';
      legend.textContent = config.label + '（' + config.quantity + '色選択してください）';
      fieldset.appendChild(legend);

      var itemsContainer = document.createElement('div');
      itemsContainer.className = 'bundle-color-spec-items';

      config.option.forEach(function(colorOpt) {
        var isSelected = selections.includes(colorOpt.value);

        var label = document.createElement('label');
        label.className = 'bundle-color-spec-item' + (isSelected ? ' is-selected' : '');

        var input = document.createElement('input');
        input.type = 'checkbox';
        input.name = 'bundle-color-' + configKey;
        input.value = colorOpt.value;
        input.dataset.configKey = configKey;
        input.dataset.maxQuantity = config.quantity;
        if (isSelected) input.checked = true;

        var span = document.createElement('span');
        span.className = 'bundle-color-spec-label';
        span.textContent = colorOpt.value;

        label.appendChild(input);
        label.appendChild(span);
        itemsContainer.appendChild(label);
      });

      fieldset.appendChild(itemsContainer);

      // 插入到变体选择器后面
      if (variantPicker && variantPicker.parentNode) {
        variantPicker.parentNode.insertBefore(fieldset, variantPicker.nextSibling);
      } else {
        insertTarget.appendChild(fieldset);
      }

      // 绑定色指定变更事件
      itemsContainer.addEventListener('change', function(e) {
        var input = e.target;
        if (!input || input.type !== 'checkbox') return;

        var key = input.dataset.configKey;
        var maxQty = parseInt(input.dataset.maxQuantity, 10) || 1;

        // 获取当前选中的颜色
        var checkboxes = itemsContainer.querySelectorAll('input[type="checkbox"]');
        var selected = [];
        checkboxes.forEach(function(cb) {
          if (cb.checked) selected.push(cb.value);
        });

        // 超过最大数量时，取消最早选中的
        if (selected.length > maxQty) {
          // 找到第一个不是刚点击的已选中项，取消它
          for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked && checkboxes[i] !== input) {
              checkboxes[i].checked = false;
              var idx = selected.indexOf(checkboxes[i].value);
              if (idx > -1) selected.splice(idx, 1);
              break;
            }
          }
        }

        // 更新选中状态样式
        checkboxes.forEach(function(cb) {
          cb.closest('.bundle-color-spec-item').classList.toggle('is-selected', cb.checked);
        });

        // 更新当前色指定选择
        currentColorSelections[key] = selected;
        console.log('--------------------------------------1',  {
            instanceId: currentInstanceId,
            bundleIndex: currentBundleIndex,
            productIndex: currentProductIndex,
            colorSelections: currentColorSelections
          })
        // 派发 bundle:color-spec-changed 事件
        window.dispatchEvent(new CustomEvent('bundle:color-spec-changed', {
          detail: {
            instanceId: currentInstanceId,
            bundleIndex: currentBundleIndex,
            productIndex: currentProductIndex,
            colorSelections: currentColorSelections
          }
        }));
      });
    });
  };

  /**
   * 监听弹框内选项变更，更新 currentSelectedOptions 用于色指定条件判断
   */
  window._onBundleModalOptionChange = function(optionName, optionValue) {
    currentSelectedOptions[optionName] = optionValue;
    updateColorSpecVisibilityInModal();
  };

})();

// ========== 通用弹框实现 ==========

/**
 * 创建产品详情弹框
 * @param {string} link - 产品页 URL
 * @param {object} options - 配置项
 *   options.source: 'revy' | 'bundle-extension'
 *   options.instanceId / bundleIndex / productIndex: 新插件回传用
 */
function createProductModal(link, options) {
  import('media-carousel');
  import('media-gallery');
  options = options || {};

  // 创建样式元素
  const modalStyle = document.createElement('style');
  modalStyle.textContent = `
    .js-modal-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.6);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1000;
      box-sizing: border-box;
      padding: 0 30px;
    }
    .js-modal-overlay.opened {
      animation: fadeIn 0.3s ease;
    }
    .js-modal-overlay.closed {
      animation: fadeIn 0.3s ease;
      animation-direction: reverse;
    }
    .js-modal-content {
      background-color: white;
      border-radius: 10px;
      max-width: 1200px;
      height: 90%;
      width: 100%;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
      position: relative;
      overflow: hidden;
    }
    .js-modal-overlay.opened .js-modal-content {
      animation: slideUp 0.3s ease;
    }
    .js-modal-overlay.closed .js-modal-content {
      animation: slideUp 0.3s ease;
      animation-direction: reverse;
    }
    @media (max-width: 768px) {
      .js-modal-overlay {
        align-items: flex-end;
        padding: 0;
      }
      .js-modal-body .js-content {
        padding: 15px;
      }
      .js-modal-content {
        width: 100%;
        max-width: 100%;
        border-radius: 10px 10px 0 0;
        margin-bottom: 0;
      }
      .js-modal-overlay.opened .js-modal-content {
        animation: slideUpMobile 0.3s ease;
      }
      .js-modal-overlay.closed .js-modal-content {
        animation: slideUpMobile 0.3s ease;
        animation-direction: reverse;
      }
    }
    .js-close-btn {
      position: absolute;
      top: 15px;
      right: 18px;
      background-color: #f0f0f0;
      border: 1px solid #ddd;
      font-size: 24px;
      cursor: pointer;
      color: #7f8c8d;
      z-index: 10;
      width: 30px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
    }
    .js-close-btn:hover {
      color: var(--color--text);
      border-color: var(--color--text);
    }
    .js-modal-body {
      min-height: 150px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    .js-loading {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .js-spinner {
      width: 50px;
      height: 50px;
      border: 5px solid #f3f3f3;
      border-top: 5px solid #aaa;
      border-radius: 50%;
      animation: spin 1s linear infinite;
      margin-bottom: 15px;
    }
    .js-content {
      display: none;
      overflow-y: auto;
      max-height: 100%;
      box-sizing: border-box;
      padding: 30px;
      content-visibility: auto;
    }
    .js-modal-body .product-single {
      margin-top: 0;
    }
    .js-modal-body .product-single > .container {
      padding: 0;
    }
    @media (min-width: 61.23em) {
      .js-modal-body .section--product-single .product-single__media {
        top: 0;
      }
    }
    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }
    @keyframes slideUp {
      from { transform: translateY(20px); opacity: 0; }
      to { transform: translateY(0); opacity: 1; }
    }
    @keyframes slideUpMobile {
      from { transform: translateY(100%); }
      to { transform: translateY(0); }
    }
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;

  // 创建遮罩层
  const modalOverlay = document.createElement('div');
  modalOverlay.className = 'js-modal-overlay opened';
  modalOverlay.id = 'jsModalOverlay';

  // 创建弹窗内容
  const modalContent = document.createElement('div');
  modalContent.className = 'js-modal-content';

  // 创建关闭按钮
  const closeBtn = document.createElement('button');
  closeBtn.className = 'js-close-btn';
  closeBtn.innerHTML = '&times;';

  // 创建弹窗主体
  const modalBody = document.createElement('div');
  modalBody.className = 'js-modal-body';

  // 创建加载状态
  const loadingState = document.createElement('div');
  loadingState.className = 'js-loading';

  const spinner = document.createElement('div');
  spinner.className = 'js-spinner';

  const loadingText = document.createElement('p');
  loadingText.textContent = '読み込み中…';

  loadingState.appendChild(spinner);
  loadingState.appendChild(loadingText);

  // 创建内容区域
  const contentArea = document.createElement('div');
  contentArea.className = 'js-content veimia_w-full';

  // 组装弹窗
  modalBody.appendChild(loadingState);
  modalBody.appendChild(contentArea);
  modalContent.appendChild(closeBtn);
  modalContent.appendChild(modalBody);
  modalOverlay.appendChild(modalStyle);
  modalOverlay.appendChild(modalContent);

  // 将弹窗添加到页面
  document.body.appendChild(modalOverlay);
  document.body.classList.add('u-scroll-disabled');

  // 控制变量
  let abortController = null;

  // 打开弹窗
  modalOverlay.style.display = 'flex';
  // var params = {
  //   content_type: options.source === 'bundle-extension' ? 'bundle_quick_view' : 'revy_bundle',
  //   series_name: options.source === 'bundle-extension' ? 'bundle_open_product_detail' : 'revy_bundle_open',
  //   section_name: options.source === 'bundle-extension' ? 'bundle' : 'revy_bundle',
  //   extra_data: link
  // };
  // setTimeout(function() { window.gtag && gtag('event', 'click_manual', params); });
  //  window.sensors && window.sensors.track('slot_click', {
  //           slot_id: 'revy_bundle',
  //           section_name: 'revy bundle',
  //           sub_module: "revy_bundle_open",
  //           extra_data: link
  //       })
  setTimeout(function() {
    modalOverlay.classList.remove('opened');
  }, 50);

  // 重置状态
  loadingState.style.display = 'flex';
  contentArea.style.display = 'none';

  // 创建新的 AbortController
  abortController = new AbortController();

  // fetch 产品页面
  fetch(link, { signal: abortController.signal })
    .then(function(response) { return response.text(); })
    .then(function(responseText) {
      const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
      const productElement = responseHTML.querySelector('div[id^="ProductSection-template"]');

      if (!productElement) {
        closeModal();
        return;
      }

      // 移除不需要的元素
      const remove_el = [
        '.cus_tan_add',
        'nav.breadcrumb',
        '#judgeme_product_reviews',
        'product-detail-top--add-cart',
        '.product-single__box__block--quantity_selector',
        '.product-form__popup',
        '.veimia_bundle_discount_product_detail',
        'veimia-variants'
      ]
      if(options.remove_el){
        remove_el.push(...options.remove_el)
      }
      remove_el.forEach(function(selector) {
        console.log(selector);
        var el = productElement.querySelector(selector);
        console.log('el', el);
        if (el) el.remove();
      });

      var uniqueId = productElement.querySelector('.product-single__box__block--variant_picker variant-radios')
        ?.getAttribute('data-section');

      if (uniqueId) {
        contentArea.innerHTML = productElement.outerHTML.replaceAll(uniqueId, uniqueId + '_modal');
      } else {
        contentArea.innerHTML = productElement.outerHTML;
      }

      // 显示内容
      loadingState.style.display = 'none';
      contentArea.style.display = 'block';

      // 如果是新插件来源，绑定变体变更监听回传事件
      if (options.source === 'bundle-extension') {
        bindBundleVariantListener(contentArea, options);
      }

      abortController = null;
    })
    .catch(function(error) {
      if (error.name === 'AbortError') {
        console.log('请求已被取消');
      } else {
        console.error('请求失败:', error);
        closeModal();
      }
    });

  // 关闭弹窗函数
  function closeModal() {
    document.body.classList.remove('u-scroll-disabled');
    modalOverlay.classList.add('closed');

    modalOverlay.addEventListener('animationend', function() {
      if (modalOverlay.parentNode) {
        document.body.removeChild(modalOverlay);
      }
    }, { once: true });

    // 兜底
    setTimeout(function() {
      if (modalOverlay.parentNode) {
        document.body.removeChild(modalOverlay);
      }
    }, 400);

    if (abortController) {
      abortController.abort();
      abortController = null;
    }
  }

  // 点击关闭按钮
  closeBtn.addEventListener('click', closeModal);

  // 点击遮罩关闭
  modalOverlay.addEventListener('click', function(e) {
    if (e.target === modalOverlay) {
      closeModal();
    }
  });
}

// ========== 新插件变体变更监听 ==========

/**
 * 绑定弹框内选项变更事件，回传给 bundle 扩展侧
 */
function bindBundleVariantListener(container, options) {
  const variantRadios = container.querySelector('variant-radios');
  if (!variantRadios) return;

  // 监听 radio change，派发 option-changed
  variantRadios.addEventListener('change', function(e) {
    const input = e.target;
    if (!input || input.type !== 'radio') return;

    const fieldset = input.closest('fieldset');
    if (!fieldset) return;

    const legend = fieldset.querySelector('legend');
    const optionName = legend ? legend.textContent.replace(/:.*$/, '').trim() : '';
    const optionValue = input.value;

    if (optionName && optionValue) {
      window.dispatchEvent(new CustomEvent('bundle:option-changed', {
        detail: {
          instanceId: options.instanceId,
          bundleIndex: options.bundleIndex,
          productIndex: options.productIndex,
          optionName: optionName,
          optionValue: optionValue
        }
      }));

      // 更新选中选项状态，用于色指定条件判断
      if (window._onBundleModalOptionChange) {
        window._onBundleModalOptionChange(optionName, optionValue);
      }
    }
  });

  // 监听组件内部的 on:variant:change 事件
  variantRadios.addEventListener('on:variant:change', function(e) {
    if (e.detail && e.detail.variant && e.detail.variant.id) {
      window.dispatchEvent(new CustomEvent('bundle:variant-changed', {
        detail: {
          instanceId: options.instanceId,
          bundleIndex: options.bundleIndex,
          productIndex: options.productIndex,
          variantId: e.detail.variant.id
        }
      }));
    }
  });

  // 渲染色指定 UI（如果有）
  if (options.colorSpec && window._renderBundleColorSpec) {
    window._renderBundleColorSpec(container, options);
  }
}
